export default "__VITE_ASSET__DOfmaIB4__"